import { useCallback, useState } from 'react';
import { IRecruiterTeamNameAutoCompleteOption, findMultipleTeamsByIds } from 'wisestep-api';

import { formatTeams } from '../../../features/jobs/helper';

const useFetchTeamNames = () => {
  const [allowedTeams, setAllowedTeams] = useState<IRecruiterTeamNameAutoCompleteOption[]>([]);
  const fetchTeamNames = useCallback(async (action: string, teamIds?: string[]) => {
    try {
      if (teamIds && teamIds.length > 0) {
        const response = await findMultipleTeamsByIds(teamIds);
        setAllowedTeams(formatTeams(response.data));
      } else {
        setAllowedTeams([]);
      }
      return true;
    } catch (error) {
      return false;
    }
  }, []);
  return {
    allowedTeams,
    fetchTeamNames,
  };
};

export default useFetchTeamNames;
